params = {};
location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (s, k, v) {
  params[k] = v;
});

var baseURL =
  "https://database.lassoapparel.com/shopify_lasso_apparel/customer_info_new.php";

function saveMeasurements(data) {
  const response = fetch(baseURL, {
    method: data.id != '' ? "PUT" : "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data)
    })
    .then(response => {
        return response.json();
    })
    .then((res) => {
      if (data.id) {
        window.location.href = "/pages/my-measurements";
      } else {
        window.location.href = "/pages/next-step";
      }
    })
    .catch(error => {
      console.log("error", error);
    });
}

function getMeasurementList(cid) {
  const request = new Request(baseURL + "?customer_id=" + cid, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      }
  });

  // Using it
  fetch(request)
  .then((response) => {
      return response.json();
  })
  .then((res) => {
      console.log('res',res);
      var custom_list = res.data;
      if(custom_list.length){
        history_list = JSON.parse(custom_list[0].update_history),
        history_list_main = document.querySelector(".measurement-history-list"),
        history_list_wrapper = document.querySelector(".history-list-wrapper");
        history_list_main.style.display = "none";
  
      for (var i = 0; i < history_list.length; i++) {
        const h_list = history_list[i],
          year = h_list.slice(0, 4),
          month = h_list.slice(5, 7),
          meridiem = parseInt(h_list.slice(11, 13)),
          day = h_list.slice(8, 10),
          time = h_list.slice(10);
        if (meridiem < 12) {
          var meridiem_str = "AM";
        } else {
          var meridiem_str = "PM";
        }
        hitory_inner =
          "<div class='inner-item'><span><svg width='28' height='30' viewBox='0 0 28 30' fill='none' xmlns='http://www.w3.org/2000/svg'><circle cx='14' cy='15' r='14' fill='#418530'/><path d='M10.7578 22.6875C11.1484 23.0781 11.8125 23.0781 12.2031 22.6875L23.6875 11.2031C24.0781 10.8125 24.0781 10.1484 23.6875 9.75781L22.2812 8.35156C21.8906 7.96094 21.2656 7.96094 20.875 8.35156L11.5 17.7266L7.08594 13.3516C6.69531 12.9609 6.07031 12.9609 5.67969 13.3516L4.27344 14.7578C3.88281 15.1484 3.88281 15.8125 4.27344 16.2031L10.7578 22.6875Z' fill='white'/></svg></span><div><p>Measurement profile saved on</p><p>" +
          day +
          "/" +
          month +
          "/" +
          year +
          time +
          meridiem_str +
          "</p></div>";
        history_list_wrapper.innerHTML += hitory_inner;
      }
  
      if (!res.error) {
        if (document.querySelector(".template-product.product--template")!= null) {
          var list = res.data;
  
          if (list.length) {
            for (var i = 0; i < list.length; i++) {
              document
                .querySelector(".measurements-select select")
                .append(
                  document
                    .querySelector("<option></option>")
                    .getAttribute("value", JSON.stringify(list[i]))
                    .text(list[i].name)
                );
            }
            document.querySelector(".measurements-select").style.display = "block";
            document
              .querySelector(".measurements-select .select-measurement")
              .trigger("change");
          } else {
            document.querySelector(".measurements-select").style.display = "none";
          }
        } else {
          var list = res.data;
          console.log('list',list);
  
          var html = "";
          html+= '<p>Your Measurement Profiles</p>'
          html += '<div class="meas-cont">';
          if (list.length) {
            for (var i = 0; i < list.length; i++) {
              let history_list = JSON.parse(list[i].update_history);
              let h_list = history_list[0],
              year = h_list.slice(0, 4),
              month = h_list.slice(5, 7),
              meridiem = parseInt(h_list.slice(11, 13)),
              day = h_list.slice(8, 10),
              time = h_list.slice(10);
              if (meridiem < 12) {
                var meridiem_str = "AM";
              } else {
                var meridiem_str = "PM";
              }
              console.log('timee', day, month, year, time, meridiem_str);
              let timeHTML = "<div>Measurement profile saved on " + day +
              "/" +
              month +
              "/" +
              year +
              time.split(':')[0]+":"+time.split(':')[1]+ " "+
              meridiem_str +
              "</p></div>";
              
              html += '<div class="measurement-list-container">';
              html += '<ul class="list-item-container">';
              for (var l in list[i]) {
                if (l != "customer_id" && l != "id") {
                  if (l == "name") {
                    html +=
                      '<li class="list-item"><div><span class="measurement-title">'+list[i][l]+' </span><span>'+timeHTML+'</span></div><div><a href="/pages/edit-measurements?id=' +
                      list[i].id +
                      '" class="btn btn--secondary">Update</a><a href="javascript:void(0);" class="btn btn--secondary delete-measurements" data-id="' +
                      list[i].id +
                      '">Delete</a></div></li>';
                  }
                }
              }
              html += "</ul>";
              html += "</div>";
            }
            html += "</div>";
            document.querySelector(".measurement-list").insertAdjacentHTML('afterbegin',html);
            // initDeleteMeasurements(); 
          } else {
            document.querySelector(".measurement-list").style.padding = 0;
            // document
            //   .querySelector(".meas-cont")
            //   .insertAdjacentHTML('afterbegin',"<p>No Measurements found</p>");
          }
        }
      }
      } else{
        document.querySelector(".measurement-list").style.padding = 0;
      }

  });
}

function getMeasurementListById(cid, id) {
  // Building the request, which you can then pass around
  const request = new Request(baseURL + "?customer_id=" + cid + "&id=" + id, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    }
  });

  fetch(request)
  .then((response) => {
    return response.json();
  })
  .then((res) => {
    console.log(res);
    if (!res.error) {
      var measurement = res.data[0];
      document
        .querySelector("input[name=id]")
        .value = parseFloat(measurement.id);
      document.querySelector("input[name=name]").value = measurement.name;
      document
        .querySelector("input[name=ankle]")
        .value = parseFloat(measurement.ankle);
      document
        .querySelector("input[name=calf]")
        .value = parseFloat(measurement.calf);
      document
        .querySelector("input[name=highwaist]")
        .value = parseFloat(measurement.highwaist);
      document
        .querySelector("input[name=hip]")
        .value = parseFloat(measurement.hip);
      document
        .querySelector("input[name=in-seam]")
        .value = parseFloat(measurement.in_seam);
      document
        .querySelector("input[name=lowwaist]")
        .value = parseFloat(measurement.lowwaist);
      document
        .querySelector("input[name=midthing]")
        .value = parseFloat(measurement.midthing);
      document
        .querySelector("input[name=out-Seam]")
        .value = parseFloat(measurement.out_seam);
      document
        .querySelector("input[name=upperthing]")
        .value = parseFloat(measurement.upperthing);
      document.querySelector("input[name=name]").val(measurement.name);
      document.querySelector(".get-start").click();
      onChangeEvent();
    }
  })
  .catch(error => {
    console.log("error", error);
  });

}

function deleteMeasurementsById(obj) {
    // Building the request, which you can then pass around
    const request = new Request(baseURL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj)
    });

    // Using it
    fetch(request)
    .then((response) => {
      return response.json();
    })
    .then((responseData) => {
      window.location.reload();
    })
    .catch(error => {
      console.log("error", error);
    });
}
document.addEventListener("DOMContentLoaded", function () {
  var isCustomerLogin = JSON.parse(document.querySelector("body").dataset.isLogin);
  if (document.querySelector(".measurement-list") != null || (document.querySelector(".template-product.product--template")!= null && isCustomerLogin)) {
    var cid = document.querySelector("body").dataset.customer;
    getMeasurementList(cid);
  }

  if (document.querySelector(".edit-measurements")!= null) {
    var cid = document.querySelector("input[name=customer_id]").value;
    var id = params["id"];
    if (id && cid) {
      getMeasurementListById(cid, id);
    } else {
      onChangeEvent();
    }
  } else {
    onChangeEvent();
  }
});


function onChangeEvent(name) {
  if (document.querySelector(".thank-you-step")!= null) {
    const list = document.querySelectorAll(".thank-you-step li");
    list.forEach((ele)=>{
      const val = ele.dataset.result;
      ele.innerHTML = document.querySelector(`input[name=${val}]`) != null ? document.querySelector(`input[name=${val}]`).value : '';
    })
  }

  const inpList = document.querySelectorAll(".measurements-input input");
  
  inpList.forEach((inp) =>{
    inp.addEventListener('input',(e) =>{
      const value = e.target.value;
      console.log('e',e.target,e.target.dataset.input);
      const liEle = document.querySelector(`.thank-you-step p.list-item span[data-result="${e.target.dataset.input}"]`);
      liEle.innerHTML = value + " inches";
    })
  })
}

/**
 * Serialize all form data into an array
 * @param {HTMLFormElement} form The form to serialize
 * @returns {Array} The serialized form data
 */
 function serializeArray (form) {
  // Create a new FormData object
  const formData = new FormData(form);

  // Create an array to hold the name/value pairs
  const pairs = [];

  // Add each name/value pair to the array
  for (const [name, value] of formData) {
    pairs.push({ name, value });
  }

  // Return the array
  return pairs;
}

document.addEventListener("DOMContentLoaded", function () {
  function deleteCookie(name) {
    Cookies.set("showpopup", "no", { expires: -1 });
  }

  document.addEventListener('click',(e)=>{
    if(e.target.matches('.welcome-modal-btns .btn')){
      Cookies.set("showpopup", "no", { expires: 1 });
    } else if(e.target.matches('.btn-save-con')){
      // document.querySelector("").addEventListener("click", function (e) {
        var measurementInput = e.target
          .closest(".measurements-step_item")
          .querySelector("input");
          // console.log('e',e.target,e.target.closest(".measurements-step_item").querySelector("input"));
        var measurementInputValue = measurementInput.value;
        //var validNumber = /[0-9]/.test(measurementInputValue);
        var validNumber = measurementInput.checkValidity();
    
        if (!measurementInputValue || !validNumber) {
          measurementInput.focus();
          e.target
            .closest(".measurements-step_item")
            .querySelector(".measurements-input")
            .classList.add("error");
          return false;
        }
        e.target
          .closest(".measurements-step_item")
          .querySelector(".measurements-input")
          .classList.remove("error");
        e.target
          .closest(".measurements-step_item")
          .classList.remove("active");
        if (e.target.closest(".measurements-step_item").nextElementSibling != null && !e.target.closest(".measurements-step_item").nextElementSibling.classList.contains('thank-you-step')) {
          console.log('next',e.target.closest(".measurements-step_item").nextElementSibling);
          e.target
            .closest(".measurements-step_item")
            .nextElementSibling
            .classList.add("active");
        } else {
          e.target
            .closest(".measurements-step")
            .querySelector(".thank-you-step")
            .style.display = "block";
        }
      // });
    } else if(e.target.matches('[data-open-popup]')){
      const popupSel = e.target.dataset.openPopup;
      createPopup(popupSel,'[data-open-popup="'+popupSel+'"]');
    } else if(e.target.matches('.final-save-button')){
      // document.querySelector("")?.addEventListener("click", function (e) {
        e.preventDefault();
        var nameInput = e.target
          .closest(".size-range-modal")
          .querySelector("input");
        var nameInputValue = nameInput.value;
        if (!nameInputValue) {
          nameInput.focus();
          e.target
            .closest(".size-range-modal")
            .classList.add("error");
          return false;
        }
    
        var mainformdata = serializeArray(document.querySelector(".mainform"));
        var formdata = serializeArray(e.target
          .closest("form"))
    
        var data = {};
        if (document.querySelector(".custom-info") != null) {
          data["email"] = document
            .querySelector(".custom-info")
            .getAttribute("customeremail");
          data["cust_name"] = document
            .querySelector(".custom-info")
            .getAttribute("customername");
        }
    
        mainformdata.forEach((obj) => {
          data[obj.name] = obj.value;
        });
    
        formdata.forEach((obj) => {
          data[obj.name] = obj.value;
        });
    
        var id = document.querySelector("input[name=id]").value;
        console.log('id',id,data.id,data);
        if (id) {
          saveMeasurements(data);
        } else {
          saveMeasurements(data);
        }
        return false;
      // });
    } else if(e.target.matches('.btn-update')){
        e.preventDefault();
        var form = document.querySelector(".update-form");
        document.querySelector(".measurements-input").classList.remove("error");
    
        var isFormValid = form[0].checkValidity();
        if (isFormValid == false) {
          document.querySelector(form).querySelectorAll(":invalid")[0].focus();
          document
            .querySelector(form)
            .querySelectorAll(":invalid")[0]
            .closest(".measurements-input")
            .classList.add("error");
          return false;
        }
        var formdata = serializeArray(form);
        var data = {};
        if (document.querySelector(".custom-info") != null) {
          data["email"] = document
            .querySelector(".custom-info")
            .getAttribute("customeremail");
          data["cust_name"] = document
            .querySelector(".custom-info")
            .getAttribute("customername");
        }
        formdata.forEach((obj) => {
          data[obj.name] = obj.value;
        });
        saveMeasurements(data);
    } else if(e.target.matches('.edit-btn')) {
      // document.querySelector(".")?.addEventListener("click", function (e) {
        e.preventDefault();
        document
          .querySelectorAll(".measurements-step_item")[0]
          .classList.add("active");
        e.target
          .closest(".measurements-step")
          .querySelector(".thank-you-step")
          .style.display = "none";
      // });
    } else if(e.target.matches('.btn-back')){
      // document.querySelector("")?.addEventListener("click", function (e) {
        e.target
          .closest(".measurements-step_item")
          .previousElementSibling
          .classList.add("active");
        e.target
          .closest(".measurements-step_item")
          .classList.remove("active");
      // });
    } else if(e.target.matches('.add-to-cart')) {
      var isCustomerLogin = JSON.parse(document.querySelector("body").dataset.isLogin);
      var measurementsName = document.querySelector("input[name='properties[name]']")?.value;
      if (!isCustomerLogin) {
        e.preventDefault();
        createPopup('#sign-notification',e.target.classList[0]);
      } else {
        if (!measurementsName) {
          e.preventDefault();
          createPopup('#add-your-measurement',e.target.classList[0]);
        }
      }
    } else if (e.target.matches('.delete-measurements')) {
        e.preventDefault();
        var cid = document.querySelector("body").dataset.customer;
        var id = e.target.dataset.id;
        var obj = {
          customer_id: cid,
          id: id,
          action: "delete_measurement_info",
        };
        deleteMeasurementsById(obj);
    }
  })


  var isCustomerLogin = JSON.parse(document.querySelector("body").dataset.isLogin);
  var popup = Cookies.get("showpopup");


  if (isCustomerLogin && !Shopify.designMode && location.href.includes('/account')) {
    Cookies.set("showpopup", "no", { expires: 1 });
    if (popup) {
    } else {
      createPopup('#welcome-modal-box','load',() => Cookies.set("showpopup", "no", { expires: 1 }));
    }
  } else {
    if (window.location.pathname != "/challenge") {
      deleteCookie("showpopup");
    }
  }
});

document.querySelector(".btn-register")?.addEventListener("click", function (e) {
  console.log('form',e.target.closest("form"),e.target.closest("form").checkValidity());
  if (e.target.closest("form").checkValidity()) {
    e.preventDefault();
    Cookies.set("showpopup", "no", { expires: 1 });
    e.target.closest("form").submit();
  } else{
    e.target.closest("form").reportValidity()
  }
});

function createPopup(popupSelector,triggerSelector, onClose = null) {
  console.log('heyyy');
    const triggerElement = triggerSelector != 'load' ? document.querySelector(triggerSelector) : 'load';
    const popupElement = document.querySelector(popupSelector);

    console.log('triggerElement',triggerElement,'popupElement',popupElement);

    if (!popupElement) {
        console.error("Trigger element or popup element not found");
        return;
    }

    // Create popup container
    const popupContainer = document.createElement("div");
    popupContainer.classList.add('popup-container', 'mfp-wrap','mfp-close-btn-in', 'mfp-auto-cursor');
    const popupOverlay = document.createElement("div");
    popupOverlay.classList.add("mfp-bg");

    // Create close button
    const closeButton = popupElement.querySelector(".popup-modal-dismiss");
    closeButton?.addEventListener("click", () => {
        popupContainer.querySelector(popupSelector).classList.add('mfp-hide');
        popupContainer.remove();
        popupOverlay.remove();
        if (typeof onClose === "function") {
            onClose();
        }
    });

    // Wrap content inside popup container
    // popupContainer.appendChild(closeButton);
    popupContainer.appendChild(popupElement);
    document.body.appendChild(popupOverlay);
    document.body.appendChild(popupContainer);

    // Show popup on trigger click
    console.log('triggerElement',triggerElement);
    document.body.appendChild(popupContainer);
    popupContainer.classList.add("visible");
    popupContainer.querySelector(popupSelector).classList.remove('mfp-hide');
    // if(triggerElement != 'load'){
    //   console.log('hiii',triggerElement);
    //   document.addEventListener("click", (e) => {
    //     console.log('e.target',e.target);
    //     if(e.target.matches(triggerSelector)){
    //       console.log('helllooo');
    //       document.body.appendChild(popupContainer);
    //       popupContainer.classList.add("visible");
    //       console.log('popsel',popupContainer.querySelector(popupSelector));
    //       popupContainer.querySelector(popupSelector).classList.remove('mfp-hide');
    //     }
    //   })
    //     triggerElement.addEventListener("click", (e) => {
    //       console.log('heuuuuu');
    //     });
    // } else{
    //     document.body.appendChild(popupContainer);
    //     popupContainer.classList.add("visible");
    //     popupContainer.querySelector(popupSelector).classList.remove('mfp-hide');
    // }
    
}

